export default __webpack_public_path__ + "static/media/One-Community-Horizontal-Homepage-Header-980x140px-2.3787316d.png";